import {HttpClient, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ISafetyProfile, SafetyProfile} from 'app/blocks/model/safety-profile.model';
import {Resource} from 'app/constants/resource';

import EntityCrudService from 'app/blocks/service/api/entity-service';
import {ResourceModel} from 'app/blocks/model/resource.model';
import {createRequestOption} from 'app/blocks/util/request-util';

@Injectable({
    providedIn: 'root'
})
export class SafetyProfileService extends EntityCrudService<ISafetyProfile> {
    constructor(http: HttpClient) {
        super(http, Resource.SAFETY_PROFILES, (obj?) => new SafetyProfile(obj));
    }

    async update(entity: ISafetyProfile): Promise<ISafetyProfile> {
        const assignDelta = (entity as any).assignResources as {id: string}[] | undefined;
        const unassignDelta = (entity as any).unassignResources as {id: string}[] | undefined;

        console.log('update:assignDelta', assignDelta);
        console.log('update:unassignDelta', unassignDelta);

        if (assignDelta && assignDelta.length > 0) {
            await this.updateAssignedResources(entity.id, assignDelta);
        }
        if (unassignDelta && unassignDelta.length > 0) {
            await this.updateUnassignedResources(entity.id, unassignDelta);
        }

        if (!assignDelta && !unassignDelta) {
            // Compute assign/unassign deltas based on current selection vs server state
            const currentSelectedIds: number[] = (entity.resources || []).map((r) => parseInt(r.id));

            const assignedResponse = await this.getAssignedResourcesPaged(entity.id, {
                page: 0,
                size: 100000,
                searchText: '',
                resourceTypeIds: [2, 3]
            });
            const previouslyAssignedIds: number[] = (assignedResponse.body || []).map((r) => r.id);

            const idsToAssign: number[] = currentSelectedIds.filter((id) => !previouslyAssignedIds.includes(id));
            const idsToUnassign: number[] = previouslyAssignedIds.filter((id) => !currentSelectedIds.includes(id));

            if (idsToAssign.length > 0) {
                await this.updateAssignedResources(
                    entity.id,
                    idsToAssign.map((id) => ({id: id.toString()}))
                );
            }

            if (idsToUnassign.length > 0) {
                await this.updateUnassignedResources(
                    entity.id,
                    idsToUnassign.map((id) => ({id: id.toString()}))
                );
            }
        }

        return super.update(entity);
    }

    updateAssignedResources = (id: number, resources: {id: string}[]) => {
        const body = resources.map((r) => parseInt(r.id));

        return this.http
            .post<ResourceModel[]>(`${this._resourceUrl}/${id}/assign-resources`, body, {
                observe: 'response'
            })
            .toPromise();
    };

    updateUnassignedResources = (id: number, resources: {id: string}[]) => {
        const body = resources.map((r) => parseInt(r.id));

        return this.http
            .post<ResourceModel[]>(`${this._resourceUrl}/${id}/unassign-resources`, body, {
                observe: 'response'
            })
            .toPromise();
    };

    getAssignedResourcesPaged = (safetyProfileId: number, req?: any): Promise<HttpResponse<ResourceModel[]>> => {
        const options = createRequestOption(req);
        return this.http
            .get<ResourceModel[]>(`${this._resourceUrl}/${safetyProfileId}/assigned-resources`, {
                params: options,
                observe: 'response'
            })
            .toPromise();
    };

    getUnassignedResourcesPaged = (safetyProfileId: number, req?: any): Promise<HttpResponse<ResourceModel[]>> => {
        const options = createRequestOption(req);
        return this.http
            .get<ResourceModel[]>(`${this._resourceUrl}/${safetyProfileId}/unassigned-resources`, {
                params: options,
                observe: 'response'
            })
            .toPromise();
    };
}
